import { ChipGroup, Field, Section } from "@/components/yarn/Field";
import { CatFace, EYES, FURS, HATS, PATTERNS, SEASON_HATS } from "@/components/yarn/Cat";

function HatPicker({ hats, draft, set, testid }) {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
      {hats.map((h) => (
        <button key={h.value} type="button" data-active={draft.hat === h.value} onClick={() => set("hat")(h.value)}
          className="chip !rounded-2xl p-2 flex flex-col items-center gap-1" data-testid={`${testid}-${h.value}`}>
          <CatFace look={{ ...draft, hat: h.value }} size={54} />
          <span className="text-xs">{h.label}</span>
        </button>
      ))}
    </div>
  );
}

export function CatOptions({ draft, set, season }) {
  const seasonal = (season?.hats || []).map((h) => ({ value: h, label: SEASON_HATS[h] }));
  return (
    <div className="patch p-5 sm:p-7 space-y-6" data-testid="cat-options">
      <Field label="Cat name" id="cat-name" value={draft.name} maxLength={20}
        onChange={(e) => set("name")(e.target.value)} data-testid="cat-name-input" />
      <Section label="Fur">
        <div className="flex flex-wrap gap-2">
          {FURS.map((f, i) => (
            <button key={f} type="button" onClick={() => set("fur")(f)} aria-label={`Fur colour ${i + 1}`}
              className={`h-11 w-11 rounded-full border-[3px] transition-transform duration-150 hover:scale-110 ${draft.fur === f ? "border-[var(--yarn-ink)] scale-110" : "border-white shadow-[0_0_0_2px_var(--yarn-stitch)]"}`}
              style={{ background: f }} data-testid={`cat-fur-${i}`} />
          ))}
        </div>
      </Section>
      <Section label="Markings">
        <ChipGroup options={PATTERNS} value={draft.pattern} onChange={set("pattern")} testid="cat-pattern" />
      </Section>
      <Section label="Eyes">
        <ChipGroup options={EYES} value={draft.eyes} onChange={set("eyes")} testid="cat-eyes" />
      </Section>
      <Section label="Hats & extras">
        <HatPicker hats={HATS} draft={draft} set={set} testid="cat-hat" />
      </Section>
      {season && (
        <Section label={`${season.label} · limited time`} hint="Seasonal outfits can only be picked during their month. Cats already wearing one get to keep it.">
          <HatPicker hats={seasonal} draft={draft} set={set} testid="cat-hat" />
        </Section>
      )}
    </div>
  );
}
